<template>
    <div class="layout-cards grid grid-cols-1 gap-6 lg:grid-cols-2 2xl:grid-cols-4">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'LayoutCards',
};
</script>
